export const VersionDetailRouting = [
  // {
  //   path: "/nVersionDetail",
  //   name: "nversionDetail",
  //   meta: { title: "工程企业管理软件" },
  //   component: () => import(/* webpackChunkName: "login" */ "@/views/versionDetail/index.vue"),
  // },
  {
    path: "/allVersionDetail",
    name: "allVersionDetail",
    meta: { title: "工程企业管理软件" },
    component: () => import(/* webpackChunkName: "login" */ "@/views/versionDetail/old-index.vue"),
  },
  {
    path: "/versionDetail",
    name: "versionDetail",
    meta: { title: "工程企业管理软件" },
    component: () => import(/* webpackChunkName: "login" */ "@/views/versionDetail/old-index.vue"),
  },
  {
    path: "/miniatureVersionDetail",
    name: "miniatureVersionDetail",
    meta: { title: "工程企业管理软件" },
    component: () => import(/* webpackChunkName: "login" */ "@/views/versionDetail/miniatureVersionDetail.vue"),
  },
  {
    path: "/productDetail",
    name: "productDetail",
    meta: { title: "工程企业管理软件" },
    component: () => import(/* webpackChunkName: "login" */ "@/views/versionDetail/product-detail.vue"),
  },
];
